<div [hidden]="!questions?.length" flex="1 1 0">
	<section class="webcast-questions-list" [ngClass]="{
			'can-manage': canModerate
		}" vbUiSortable [sortableOptions]="sortableOptions" [sortableDisabled]="!allowReordering" (onSort)="onSort($event)" layout="column" layout-wrap="false">
		<ng-container *ngFor="let question of questions; trackBy: trackByQuestionNumber">
			<div class="animate-repeat" [ngClass]="{
					'draggable': allowReordering
				}">
				@if (canModerate) {
					<vb-webcast-question-manage-card [context]="context" [webcastId]="webcast.id" [question]="question" [canModerate]="canModerate" [allowReordering]="allowReordering" [ngClass]="{
							'is-closed': question.isClosed,
							'is-queued': question.isQueued,
							'direct-reply-in-progress': question.isDirectReplyInProgress
						}">
					</vb-webcast-question-manage-card>
				} @else {
					<vb-webcast-question-attendee-card [question]="question" [questionContext]="questionContext">
					</vb-webcast-question-attendee-card>
				}
			</div>
		</ng-container>
	</section>
</div>

